import ConfirmationModal from '@/components/Modal/ConfirmationModal';
import { Button, SxProps, Theme } from '@mui/material';
import { useCallback, useState } from 'react';

interface IProps {
  sx?: SxProps<Theme>;
  onRemove?: () => void;
}

const RemoveButton = ({ sx, onRemove }: IProps) => {
  const [isOpenedConfirmation, setIsOpenedConfirmation] = useState(false);

  const onConfirm = useCallback(() => {
    onRemove?.();
    setIsOpenedConfirmation(false);
  }, [onRemove, setIsOpenedConfirmation]);

  const onActionClick = useCallback(async () => {
    setIsOpenedConfirmation(true);
  }, [setIsOpenedConfirmation]);

  const onConfirmationClose = useCallback(() => {
    setIsOpenedConfirmation(false);
  }, [setIsOpenedConfirmation]);

  return (
    <>
      <Button
        variant='outlined'
        color='primary'
        sx={{
          marginLeft: '8px',
          textWrap: 'nowrap',
          minWidth: 'unset',
          ...sx,
        }}
        onClick={onActionClick}
      >
        Remove
      </Button>
      {isOpenedConfirmation && (
        <ConfirmationModal
          open={isOpenedConfirmation}
          onClose={onConfirmationClose}
          onConfirm={onConfirm}
          text='Are you sure you want to remove creative association?'
        />
      )}
    </>
  );
};

export default RemoveButton;
